<app-navbar title="Menu WWW">
	<div class="button-row">
		<button class="btn btn-primary me-3 submit-button" (click)="submit()">Zapisz</button>
		<button class="btn btn-danger" routerLink="../"><i class="fas fa-chevron-left"></i>Powrót</button>
	</div>
</app-navbar>
<div class="container">
	<form class="mt-4" *ngIf="bannerForm" [formGroup]="bannerForm">
		<div class="form-floating">
			<mat-label>Nazwa: </mat-label>
			<mat-form-field class="w-100" appearance="outline">
				<input matInput formControlName="name" required />
				<mat-error>Nazwa jest wymagana</mat-error>
			</mat-form-field>
		</div>
		<div class="form-floating">
			<mat-label>Link: </mat-label>
			<mat-form-field class="w-100" appearance="outline">
				<input matInput formControlName="link" required />
				<mat-error>Link jest wymagany</mat-error>
			</mat-form-field>
		</div>
		<div class="form-floating">
			<mat-label>Tekst: </mat-label>
			<mat-form-field class="w-100" appearance="outline">
				<input matInput formControlName="text" required />
				<mat-error>Tekst jest wymagany</mat-error>
			</mat-form-field>
		</div>
		<div class="form-floating">
			<mat-form-field appearance="outline" class="w-100">
				<mat-label>Status :</mat-label>
				<mat-select formControlName="isActive" required>
					<mat-option id="isActive" *ngFor="let item of isActive" [value]="item.id">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<label>Zdjęcie (urządzenie desktopowe)</label>
		<div class="form-floating mt-2 mb-4">
			<div *ngIf="photo"><img [src]="photo" alt="desktop-photo" /></div>
			<button class="btn btn-primary me-3" (click)="deletePhoto(BannerPhotoMode.DESKTOP)">Usuń</button>
			<input
				type="file"
				class="file-input file-button"
				(change)="onFileSelected($event, BannerPhotoMode.DESKTOP)"
				#fileUpload
			/>
			<mat-error class="multimedia-error" *ngIf="bannerForm.controls['multimedia'].errors?.required"
				>Zdjęcie jest wymagane</mat-error
			>
		</div>
		<label>Zdjęcie (urządzenie mobilne)</label>
		<div class="form-floating mt-2 mb-4">
			<div *ngIf="photoMobile">
				<img [src]="photoMobile" alt="mobile-photo" />
			</div>
			<button class="btn btn-primary me-3" (click)="deletePhoto(BannerPhotoMode.MOBILE)">Usuń</button>
			<input
				type="file"
				class="file-input file-button"
				(change)="onFileSelected($event, BannerPhotoMode.MOBILE)"
				#fileMobileUpload
			/>
		</div>
	</form>
</div>
